import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { IoPrintOutline } from "react-icons/io5";
import { useReactToPrint } from "react-to-print";

const FormShowPayment = () => {
   const [contract_no, setContractNo] = useState("");
   const [client_name, setClientName] = useState("");
   const [address, setAddress] = useState("");
   const [email, setEmail] = useState("");
   const [phone, setPhone] = useState("");
   const [start_guarantee, setStartGuarantee] = useState(""); 
   const [end_guarantee, setEndGuarantee] = useState("");
   const [start_contract, setStartContract] = useState(""); 
   const [end_contract, setEndContract] = useState("");
   const [paid_status, setPaidStatus] = useState("");
   const [time_paid, setTimePaid] = useState("");
   const [contract_value, setContractValue] = useState(""); 
   const [paid_amount, setPaidAmount] = useState("");
   const [due_amount, setDueAmount] = useState(0);
   const [contract_payment, setContractPayment] = useState([]);

   const [companyname, setCompanyName] = useState("");
   const [companyaddress, setCompanyAddress] = useState("");
   const [companyemail, setCompanyEmail] = useState("");
   const [companyphone, setCompanyPhone] = useState("");
   const [companyfax, setCompanyFax] = useState("");
   const [url, setUrl] = useState("");
   const [msg, setMsg] = useState("");
   const { id, idClient, idSale } = useParams();
   // Access the environment variables
   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
   const API_KEY = process.env.REACT_APP_API_KEY;

   const componentRef = useRef();
   
   const handlePrint = useReactToPrint({
      documentTitle: 'Title',
      contentRef: componentRef,
   })

   useEffect(() => {
      const getContractById = async () => {
         try {
            //get data sales contract
            const response = await axios.get(
               `${API_BASE_URL}/contracts/${id}`, {
                  headers: {
                        'X-API-Key': API_KEY
                  },
               }
            );     
            // get data cutomer
            const idClient = response.data.clientId;
            const responseclient = await axios.get(
               `${API_BASE_URL}/customers/${idClient}`, {
                  headers: {
                        'X-API-Key': API_KEY
                  },
               }
            );

            // get data product item
            const idContract = response.data.id;
            const contractpayment = await axios.get(
               `${API_BASE_URL}/contractpayment/${idContract}`, {
                  headers: {
                        'X-API-Key': API_KEY
                  },
               }
            );

            setContractPayment(contractpayment.data);

            setClientName(responseclient.data.name);
            setAddress(responseclient.data.address);
            setPhone(responseclient.data.phone);
            setEmail(responseclient.data.email);
           
            setContractNo(response.data.contract_no);
            setContractValue(response.data.contract_value);
            setStartGuarantee(response.data.start_guarantee);
            setEndGuarantee(response.data.end_guarantee);
            setStartContract(response.data.start_contract);
            setEndContract(response.data.end_contract);
           
            setPaidStatus(response.data.paid_status);
            setTimePaid(response.data.last_time_paid);
            setPaidAmount(response.data.paid_amount);
            setDueAmount(response.data.due_amount);
           
           
         } catch (error) {
            console.error(error);
            if (error.response) {
               setMsg(error.response.data.msg);
            }
         }
      };

      const getCompany = async () => {
         try {
            //get data sales contract
            const response = await axios.get(`${API_BASE_URL}/companies`, {
               headers: {
                     'X-API-Key': API_KEY
               },
            });  
            //console.log(response.data[0].name); 
            setCompanyName(response.data[0].name);
            setCompanyAddress(response.data[0].address);  
            setCompanyEmail(response.data[0].email);  
            setCompanyPhone(response.data[0].phone);  
            setCompanyFax(response.data[0].fax);
            setUrl(response.data[0].url);
         } catch (error) {
               console.error(error);
               if (error.response) {
                  setMsg(error.response.data.msg);
               }
         }
      };
      getContractById();
      getCompany();
   }, [id, idClient, idSale]);
   return (
      <div className="container">
         <div className="columns">           
           <div className="column is-full">
            <div className="buttons is-right">
               <button className="button is-link mr-2" onClick={handlePrint}><IoPrintOutline /> Print</button>
               <Link to="/contracts">
                  <button className="button is-black mr-4">
                     Back
                  </button>
               </Link>
            </div>
           </div>
         </div>
         <div className="pl-4 pr-4" ref={componentRef}>
            <div className="columns mt-2">
               <div className="column has-text-left is-2">
                  <figure className="image is-5by3">
                     <img src={url} alt="Preview Image" />
                  </figure>
               </div>
               <div className="column has-text-centered is-8">
                  <h1 className="title has-text-weight-bold is-size-5">{companyname}</h1>
                  <h3 className="title is-size-7">{companyaddress}<br/>Phone: {companyphone}, Fax: {companyfax}, Email: {companyemail}</h3>  
               </div>
            </div>
            <hr/>
            <h1 className="title has-text-centered has-text-weight-bold is-size-5">DETAILS OF PAYMENT</h1>
            <h3 className="title is-size-6">DATA CONTRACT</h3>  
            <div className="field is-horizontal">
               <div className="field-label is-normal has-text-right">
                  <label className="label">Contract_No:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={contract_no} onChange={(e) => setContractNo(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div>     
            <div className="field is-horizontal">
               <div className="field-label is-normal has-text-right">
                  <label className="label">Customer_Nama:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={client_name} onChange={(e) => setClientName(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div>
            <div className="field is-horizontal">
               <div className="field-label is-normal">
                  <label className="label">Address:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={address} onChange={(e) => setAddress(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div> 
            <div className="field is-horizontal">
               <div className="field-label is-normal">
                  <label className="label">Email:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={email} onChange={(e) => setEmail(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div> 
            <div className="field is-horizontal">
               <div className="field-label is-normal">
                  <label className="label">Phone:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={phone || ""} onChange={(e) => setPhone(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div> 
            <div className="field is-horizontal">
               <div className="field-label is-normal has-text-right">
                  <label className="label">Contract_Value:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <NumericFormat
                           disabled
                           id="contract_value"
                           className="input has-text-weight-bold"
                           value={contract_value}
                           thousandSeparator={true}
                           decimalScale={2}
                           fixedDecimalScale={true}
                           allowNegative={false}
                           valueIsNumericString={true} 
                        />
                     </div>
                  </div>
               </div>
            </div> 
            <div className="field is-horizontal">
               <div className="field-label is-normal has-text-right">
                  <label className="label">Due_Amount:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <NumericFormat
                           disabled
                           id="contract_value"
                           className="input has-text-weight-bold"
                           value={due_amount}
                           thousandSeparator={true}
                           decimalScale={2}
                           fixedDecimalScale={true}
                           allowNegative={false}
                           valueIsNumericString={true} 
                        />
                     </div>
                  </div>
               </div>
            </div>   
            <div className="field is-horizontal">
               <div className="field-label is-normal">
                  <label className="label">Paid_Status:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input has-text-weight-bold" type="text" value={paid_status || ""} onChange={(e) => setPaidStatus(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div> 
            <h3 className="title is-size-6">PAYMENT HISTORY</h3>
            <table className="table is-striped is-fullwidth is-size-6">
               <thead>
                  <tr>
                     <th style={{width: "1%"}}>No</th>
                     <th className="has-text-centered">Paid_Amount</th>
                     <th className="has-text-centered">Payment_Methode</th>
                     <th className="has-text-centered">Note</th>
                     <th className="has-text-centered">Time_Paid</th>
                  </tr>
               </thead>
               <tbody>
                     {contract_payment.map((item, index) => (
                        <tr key={item.uuid}>
                           <td>{index + 1}</td>
                           <td className="has-text-right">
                              <NumericFormat
                                 value={item.amount}
                                 displayType="text" // Renders as a <span> instead of an input
                                 thousandSeparator={true}
                                 decimalScale={2}
                                 fixedDecimalScale={true} />
                           </td>
                           <td className="has-text-centered">{item.payment_method}</td>                                                
                           <td>{item.note}</td>
                           <td className="has-text-centered">{new Date(item.updatedAt).toLocaleDateString('id', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                                hour: 'numeric',
                                minute: 'numeric',
                                hour12: false,
                                })
                                }
                            </td>
                        </tr>
                     ))}
               </tbody>
            </table> 
         </div>                         
      </div>
   );
};

export default FormShowPayment;
